import React from 'react';
import moment from 'moment';

const BookRequestTable = ({ data, modalHandler }) => {
  const renderRow = (row, index) => {
    const requestId = row.id;

    return (
      <tr key={index} className="booksRequest__table-row" onClick={() => modalHandler(true, requestId)}>
        <td className="td-center">
          {row.creatorname}
        </td>
        <td className="td-center">
          {row.cathedra}
        </td>
        <td className="td-center">
          {row.sumbooks}
        </td>
        <td className="td-center">
          {row.sumdigitalbooks}
        </td>
        <td className="td-center">
          {moment(row.creationtime).format('DD.MM.YYYY')}
        </td>
      </tr>
    );
  }

  return (
    <table>
      <thead>
        <tr>
          <th className="table-title" width="20%" >ФИО</th>
          <th className="table-title" width="25%" >Дисциплина / учебный курс</th>
          <th className="table-title" width="15%" >Количество</th>
          <th className="table-title" width="15%" >Электр. копий</th>
          <th className="table-title" width="25%" >Дата заказа</th>
        </tr>
      </thead>
      <tbody>
        {data && data.map(renderRow)}
      </tbody>
    </table>
  );
}

export default BookRequestTable;
